const isDev = process.env.NODE_ENV === "development";

export const persist = {
  key: `${process.env.REACT_APP_NAME}.${isDev ? "dev" : "prod"}.${
    process.env.REACT_APP_PERSIST_VERSION
  }`,
  whitelist: isDev ? ["auth"] : ["auth"],
  version: process.env.REACT_APP_PERSIST_VERSION,
};
